import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { BaseUpsertTransactionSideEffect } from './BaseUpsertTransactionSideEffect';

export const UpsertAdvanceSideEffectContext = BaseUpsertTransactionSideEffect.extend({
  advanceId: FeeId,
});
export const UpsertAdvanceSideEffect = UpsertAdvanceSideEffectContext.extend({
  type: z.literal('upsertAdvance'),
});
export type UpsertAdvanceSideEffect = z.infer<typeof UpsertAdvanceSideEffect>;
